
import store from '@/store';
import { defineComponent } from 'vue';
import { GlobalPagination } from '@/interfaces/panel/global-pagination.model';
import IpgTransactionSkelton from '@/components/transactionsComponents/IpgTransactionSkelton.vue';
import LogsSysytemTableComponent from '@/components/appComponents/LogsSysytemTable.vue';
import CustomPaginationComponent from '@/components/appComponents/CustomPagination.vue';

export default defineComponent({
    name: "UsersListPage",

    components: { IpgTransactionSkelton, LogsSysytemTableComponent, CustomPaginationComponent },

    data() {
        return {
            user: ""
        }
    },

    computed: {
        getLoadingPanel(): boolean {
            return store.getters["panel/getLoadingPanel"];
        },

        getSystemLogs() {
            return store.getters["panel/getSystemLogs"];
        },

        getGlobalPagination(): GlobalPagination {
            return store.getters["panel/getGlobalPagination"];
        }
    },

    methods: {
        handelPagination() {
            store.dispatch("panel/getSystemLogsRequest");
        }
    },

    mounted() {
        store.dispatch("panel/getSystemLogsRequest");
    }
})
